import { CurrencyType } from './enum/CurrencyType';

export class CacType {
  currency: string;
  type: CurrencyType;

  constructor(currency: string, type: CurrencyType) {
    this.currency = currency;
    this.type = type;
  }
}
